export default [
    "15 15",
    '<path d="M2.5 8H12.5M12.5 8L8.75 4.25M12.5 8L8.75 11.75" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>']